import { FC } from 'react';
import { Rect } from '../rect';

type Props = HasClassName<{
  size: number;
}>;

export const Entry: FC<Props> = ({ size, className }) => (
  <Rect className={className} width={size} height={size} borderRadius={9999} />
);
